module.exports = __webpack_public_path__ + "img/home_identity_check.08405a62.png";